import { FaFacebookF } from "components/atoms/Icon/fa/FaFacebookF";
import { FaLinkedinIn } from "components/atoms/Icon/fa/FaLinkedinIn";
import { FaTwitter } from "components/atoms/Icon/fa/FaTwitter";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

import styles from "./Index.module.scss";
const FaIcons = {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
};

export default function CardImageDes({ Card, total }) {
  return (
    <>
      <div className={` container ${styles.cardContainer}`}>
        <div className={`${styles.cardWrapper}`}>
          <div className={`${styles.imgCard}`}>
            <Img src={Card.image.src} alt={Card.image.altText} />
          </div>
          <div className="lg:ml-52 lg:pl-10">
            <Title
              as="h1"
              className="mb-4 mt-6 text-bbc-30px font-semibold text-bbc-brand-800 lg:mt-0"
            >
              {Card.title}
            </Title>
            <div className="bbc-gray text-base leading-[26px]">
              {Card?.thedescription.map((item, index) => (
                <div
                  className="mb-4"
                  key={index}
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              ))}
            </div>
            <div className="">
              <em className="mb-2 lg:float-left">
                A collection of {total} posts
              </em>
              <div className="lg:float-right">
                {Card?.socialNetwork.map((item, index) => {
                  const As = FaIcons[item.icon];

                  return (
                    <a
                      key={index}
                      href={item.url}
                      rel="noreferrer"
                      className={
                        "mt-4 mr-2 inline-block h-8 w-8 rounded-full py-2 text-center text-white lg:mt-0 lg:mr-0 lg:ml-2"
                      }
                      target="_blank"
                      style={{ backgroundColor: `${item.color}` }}
                    >
                      <As className="mx-auto" />
                    </a>
                  );
                })}
              </div>
              <div className="clear-both"></div>
            </div>
          </div>
          <div className="clear-both"></div>
        </div>
      </div>
    </>
  );
}
